import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const DragHandleHorizontal = forwardRef(function DragHandleHorizontal(props, ref) {
  const { color = '#000000', size = 24, ...others } = props;

  return (
    <svg
      ref={ref}
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...others}
    >
      <path clipRule="evenodd" d="M2 8.57895H22V7H2V8.57895ZM2 17H22V15.4211H2V17Z" fill={color} fillRule="evenodd" />
    </svg>
  );
});

DragHandleHorizontal.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DragHandleHorizontal;
